import * as yup from 'yup'
import { trimString } from 'common/utils/yupSchemaUtils'

export const schema = yup
  .object({
    name: yup
      .string()
      .required('Series name required')
      .min(4, 'Series name must be at least 4 characters')
      .transform(trimString),
    // programs: yup.array().min(1).of(
    //   yup.string()
    // .test('invalid-program-group', checkProgramIsValid)
    // ),
    subtitle: yup.string().max(36, 'Subtitle must be under 36 characters'),
    description: yup.string().max(600, 'Description must be under 600 characters'),
    color: yup.string(),
    previewImg: yup.string(),
  })
  .required()
